import { render, staticRenderFns } from "./LabNewDensityOfLiquidsAndSolids.vue?vue&type=template&id=822f6106&"
import script from "./LabNewDensityOfLiquidsAndSolids.vue?vue&type=script&lang=ts&"
export * from "./LabNewDensityOfLiquidsAndSolids.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports